import { renderElement } from "../../utils/use-render.js";
import { MenuRadioItemContextProvider, useMenuContext, useMenuRadioGroupContext } from "./context.js";
import { completeMenuItemSelection } from "@videojs/core/dom";
import { forwardRef, useCallback, useEffect, useRef } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/ui/menu/radio-item.tsx
/** A radio-style menu item. Renders a `<div>` with `role="menuitemradio"`. */
const MenuRadioItem = forwardRef(function MenuRadioItem({ render, className, style, value, disabled, onClick, ...elementProps }, forwardedRef) {
	const { menu, state } = useMenuContext();
	const { value: groupValue, onValueChange } = useMenuRadioGroupContext();
	const elementRef = useRef(null);
	const checked = groupValue === value;
	useEffect(() => {
		const element = elementRef.current;
		if (!element) return;
		return menu.registerItem(element);
	}, [menu]);
	const handleClick = useCallback((event) => {
		if (disabled) return;
		onClick?.(event);
		if (event.defaultPrevented) return;
		onValueChange(value);
		completeMenuItemSelection(menu);
	}, [
		disabled,
		onClick,
		onValueChange,
		value,
		menu
	]);
	const handlePointerEnter = useCallback(() => {
		const element = elementRef.current;
		if (!element || disabled) return;
		menu.highlight(element, {
			focus: false,
			pointer: true
		});
	}, [menu, disabled]);
	return /* @__PURE__ */ jsx(MenuRadioItemContextProvider, {
		value: checked,
		children: renderElement("div", {
			render,
			className,
			style
		}, {
			state,
			ref: [forwardedRef, elementRef],
			props: [{
				role: "menuitemradio",
				"aria-checked": checked,
				"aria-disabled": disabled ? true : void 0,
				onClick: handleClick,
				onPointerEnter: handlePointerEnter
			}, elementProps]
		})
	});
});
//#endregion
export { MenuRadioItem };

//# sourceMappingURL=radio-item.js.map